module.exports = __webpack_public_path__ + "static/media/blank-sketches.cce427bd.svg";